const getDefaultState = () => {
  return {
    activeSymbols: { equity: [], options: [] },
    activeTab: null,
    userName: String,
    userGroups: [],
    wsUsersession: false,
    // null, not the `String` constructor: `String` is truthy, so `if (!id)`
    // guards passed and sent "function String()..." as a REST path segment.
    currentlySelectedAccountInformation: null,
    currentlySelectedAccountInformationArray: [],
    currentlySelectedAccountInformationId: null,
    notification: String,
    accountInfoUpdate: String,
    viewableAccounts: [],
    isClient: Boolean,
    marquee_watchlist: [],
    newOrder: {},
    subscriptionTrigger: String,
    systemConfig: [],
    userPermissions: [],
    // Bumped after a broker writes permissions so trader profile panels refetch.
    userPermissionsRevision: 0,
    darkside: false,
    selectedSubAccountNumber: null,
    sub: null,
  }
}

export default {
  state: getDefaultState(),
  getters: {
    getactiveSymbols: (state) => state.activeSymbols,
    getActiveTab: (state) => state.activeTab,
    getUserGroups: (state) => state.userGroups,
    getUserName: (state) => state.userName,
    getwsUsersession: (state) => state.wsUsersession,
    getcurrentlySelectedAccountInformation: (state) =>
      state.currentlySelectedAccountInformation,
    getcurrentlySelectedAccountInformationArray: (state) =>
      state.currentlySelectedAccountInformationArray,
    getcurrentlySelectedAccountInformationId: (state) =>
      state.currentlySelectedAccountInformationId,
    getviewableAccounts: (state) => state.viewableAccounts,
    getisClient: (state) => state.isClient,
    getmarquee_watchlist: (state) => state.marquee_watchlist,
    getNotification: (state) => state.notification,
    getNewOrder: (state) => state.newOrder,
    getSubscriptionTrigger: (state) => state.subscriptionTrigger,
    getAccountInfoUpdate: (state) => state.accountInfoUpdate,
    getSystemConfig: (state) => state.systemConfig,
    getUserPermissions: (state) => state.userPermissions,
    getUserPermissionsRevision: (state) => state.userPermissionsRevision,
    getDarkSide: (state) => state.darkside,
    getSelectedSubAccountNumber: (state) => state.selectedSubAccountNumber,
    getSub: (state) => state.sub,
    getIsUserProfileExist: (state) =>
      !Array.isArray(state.currentlySelectedAccountInformationArray),
  },
  mutations: {
    // localStorage.setItem( 'setcurrentlySelectedAccountInformation', this.selectedAccountNumber );
    // console.log(localStorage)
    setSelectedSubAccountNumber: (state, payload) => {
      state.selectedSubAccountNumber = payload
    },
    setDarkSide: (state, payload) => {
      state.darkside = payload
    },
    setSystemConfig: (state, payload) => {
      state.systemConfig = payload
    },
    setUserPermissions: (state, value) => {
      state.userPermissions = value
    },
    bumpUserPermissionsRevision: (state) => {
      state.userPermissionsRevision += 1
    },
    setEquitySymbols: (state, payload) => {
      state.activeSymbols.equity = [...payload]
    },
    setOptionsSymbols: (state, payload) => {
      state.activeSymbols.options = payload
    },
    setActiveTab: (state, payload) => {
      state.activeTab = payload
    },
    setmarquee_watchlist: (state, payload) => {
      state.marquee_watchlist = []
      state.marquee_watchlist = payload
    },
    setUserGroups: (state, groups) => {
      state.userGroups = groups || JSON.parse(localStorage.getItem('groups'))
    },
    setUserName: (state, name) => {
      state.userName = name
    },
    setSub: (state, sub) => {
      state.sub = sub
    },
    setwsUsersession: (state, value) => {
      state.wsUsersession = value
    },
    setNotification: (state, value) => {
      state.notification = value
    },
    setNewOrder: (state, value) => {
      state.newOrder = value
    },
    setSubscriptionTrigger: (state, value) => {
      state.subscriptionTrigger = value
    },
    setAccountInfoUpdate: (state, value) => {
      state.AccountInfoUpdate = value
    },
    setcurrentlySelectedAccountInformation: (state, value) => {
      state.currentlySelectedAccountInformation = value
    },
    setAccountWatchlistDropdown: (state, value) => {
      state.currentlySelectedAccountInformationArray.userProfile.accounts.items[0].selectedWatchlist =
        value
    },
    setAccountWatchlist: (state, value) => {
      state.currentlySelectedAccountInformationArray.userProfile.accounts.items[0].selectedWatchlist[
        localStorage.getItem('selectedWatchlist') || 0
      ].selectedStocks = value
    },
    addNewWatchlist: (state, value) => {
      state.currentlySelectedAccountInformationArray.userProfile.accounts.items[0].selectedWatchlist.push(
        value
      )
    },
    setcurrentlySelectedAccountInformationArray: (state, value) => {
      state.currentlySelectedAccountInformationArray = value
    },
    setcurrentlySelectedAccountInformationId: (state, value) => {
      state.currentlySelectedAccountInformationId = value
    },
    setviewableAccounts: (state, status) => {
      state.viewableAccounts = status
    },
    setisClient: (state, status) => {
      state.isClient = status
    },
    setUserStoredSubBalance: (state, status) => {
      for (let subAccount of state.currentlySelectedAccountInformationArray
        .userProfile.accounts.items[0].subAccounts.items) {
        if (subAccount.subAccountNumber == status.subAccountNumber) {
          subAccount.balance = status
        }
      }
    },
    updateSystemConfig: (state, items) => {
      state.systemConfig = Object.assign(state.systemConfig, {
        symbolTradeRestrictions: [],
      })
      items.forEach((item) => {
        state.systemConfig.symbolTradeRestrictions.push({
          id: item.id,
          symbol: item.symbol,
          restrictionType: item.restrictionType,
        })
      })
    },
    updateTradeRestrictions: (state, items) => {
      state.systemConfig.symbolTradeRestrictions.push({
        id: items.id,
        symbol: items.symbol,
        restrictionType: items.restrictionType,
      })
    },
    removeTradeRestrictions: (state, index) => {
      state.systemConfig.symbolTradeRestrictions.splice(index, 1)
    },
    resetProfileState: (state) => {
      Object.assign(state, getDefaultState())
    },
    updateUserProfile: (state, userProfileObj) => {
      for (const keyToUpdate in userProfileObj) {
        if (Object.prototype.hasOwnProperty.call(userProfileObj, keyToUpdate)) {
          state.currentlySelectedAccountInformationArray.userProfile[
            keyToUpdate
          ] = userProfileObj[keyToUpdate]
        }
      }
    },
  },
}
